var _defs, _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _rect3, _path7, _path8, _path9, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path0, _path1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path10, _path11, _circle, _circle2, _circle3, _rect19, _rect20, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 392,
    height: 262,
    viewBox: "0 0 392 262",
    fill: "none",
    id: "svg82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.454529 195.546C0.454529 87.5488 88.0032 0 196 0V0C303.997 0 391.545 87.5487 391.545 195.545V261.448H0.454529V195.546Z",
    fill: "#FF7967",
    id: "path2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 173.312,
    y: 151.251,
    width: 45.3752,
    height: 34.5716,
    fill: "#9E2A2B",
    id: "rect4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196 60.5005L218.688 151.251H173.312L196 60.5005Z",
    fill: "#38040E",
    id: "path6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130.098,
    y: 185.822,
    width: 129.643,
    height: 28.0894,
    fill: "#38040E",
    id: "rect8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.705 190.144L173.312 213.912H130.098L151.705 190.144Z",
    fill: "#FF7967",
    id: "path10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.92 190.144L216.527 213.912H173.312L194.92 190.144Z",
    fill: "#FF7967",
    id: "path12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.715 170.697L339.688 198.787H259.741L299.715 170.697Z",
    fill: "#38040E",
    id: "path14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.134 190.144L259.741 213.912H216.527L238.134 190.144Z",
    fill: "#FF7967",
    id: "path16"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 130.098,
    y: 213.912,
    width: 129.643,
    height: 47.5359,
    fill: "#FF7967",
    id: "rect20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.835 229.718C155.908 226.873 154.142 224.376 151.769 222.555V222.555L151.769 222.555L151.769 222.555V222.555C149.395 224.376 147.629 226.873 146.703 229.718L146.303 230.943H146.303V246.322H157.234V230.943H157.234L156.835 229.718Z",
    fill: "#FFD1A7",
    id: "path22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.344 229.718C243.417 226.873 241.651 224.376 239.278 222.555V222.555L239.278 222.555L239.278 222.555V222.555C236.905 224.376 235.138 226.873 234.212 229.718L233.813 230.943H233.813V246.322H244.743V230.943H244.743L244.344 229.718Z",
    fill: "#FFD1A7",
    id: "path24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.955 231.197H205.723V261.447H181.955V231.197Z",
    fill: "#9E2A2B",
    id: "path26"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 187.357,
    y: 237.68,
    width: 12.9643,
    height: 23.768,
    fill: "#38040E",
    id: "rect28"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 259.741,
    y: 198.787,
    width: 131.804,
    height: 62.661,
    fill: "#9E2A2B",
    id: "rect30"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 346.17,
    y: 235.519,
    width: 36.7323,
    height: 25.9287,
    fill: "#540B0E",
    id: "rect32"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 266.224,
    y: 235.519,
    width: 30.2501,
    height: 15.1251,
    fill: "#FFD1A7",
    id: "rect34"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 266.224,
    y: 211.751,
    width: 30.2501,
    height: 15.1251,
    fill: "#FF7967",
    id: "rect36"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 302.956,
    y: 235.519,
    width: 30.2501,
    height: 15.1251,
    fill: "#FFD1A7",
    id: "rect38"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 302.956,
    y: 211.751,
    width: 30.2501,
    height: 15.1251,
    fill: "#FF7967",
    id: "rect40"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 346.17,
    y: 211.751,
    width: 36.7323,
    height: 15.1251,
    fill: "#FF7967",
    id: "rect42"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6334 149.09H130.098V261.447H56.6334V149.09Z",
    fill: "#9E2A2B",
    id: "path44"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6781 166.376H85.8032V181.831H70.6781V166.376ZM70.6781 197.485H85.8032V212.94H70.6781V197.485ZM116.053 197.485H100.928V212.94H116.053V197.485Z",
    fill: "#FF7967",
    id: "path46"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 70.6781,
    y: 228.395,
    width: 15.1251,
    height: 15.4553,
    fill: "#FFD1A7",
    id: "rect48"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 70.6781,
    y: 228.395,
    width: 15.1251,
    height: 15.4553,
    fill: "#FFD1A7",
    id: "rect50"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 100.928,
    y: 228.395,
    width: 15.1251,
    height: 15.4553,
    fill: "#FFD1A7",
    id: "rect52"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 100.928,
    y: 228.395,
    width: 15.1251,
    height: 15.4553,
    fill: "#FF7967",
    id: "rect54"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 0.454529,
    y: 203.108,
    width: 56.1788,
    height: 58.3395,
    fill: "#540B0E",
    id: "rect56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 9.09741,
    y: 216.072,
    width: 12.9643,
    height: 12.9643,
    fill: "#FF7967",
    id: "rect58"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 9.09741,
    y: 237.68,
    width: 12.9643,
    height: 12.9643,
    fill: "#FF7967",
    id: "rect60"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0261,
    y: 216.072,
    width: 12.9643,
    height: 12.9643,
    fill: "#FF7967",
    id: "rect62"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0261,
    y: 237.68,
    width: 12.9643,
    height: 12.9643,
    fill: "#FFD1A7",
    id: "rect64"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5439 170.697L56.6333 203.108H0.454529L28.5439 170.697Z",
    fill: "#540B0E",
    id: "path66"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.955 230.117C181.955 223.554 187.276 218.233 193.839 218.233V218.233C200.403 218.233 205.723 223.554 205.723 230.117V231.197H181.955V230.117Z",
    fill: "#9E2A2B",
    id: "path68"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 193.839,
    cy: 226.876,
    r: 2.16072,
    fill: "#FF7967",
    id: "circle70"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.518,
    cy: 231.197,
    r: 2.16072,
    fill: "#FF7967",
    id: "circle72"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.161,
    cy: 231.197,
    r: 2.16072,
    fill: "#FF7967",
    id: "circle74"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 100.928,
    y: 166.376,
    width: 15.1251,
    height: 15.4553,
    fill: "#FFD1A7",
    id: "rect76"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 70.6781,
    y: 166.376,
    width: 15.1251,
    height: 15.4553,
    fill: "#FFD1A7",
    id: "rect78"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.544,
    cy: 192.304,
    r: 2.16072,
    fill: "#FFD1A7",
    id: "circle80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4f2b23bb782b0cd99a9c00060c5db1dd.svg";
export { ForwardRef as ReactComponent };